import { Component, Input, SimpleChanges } from '@angular/core';
import { NavController } from 'ionic-angular';
import { ApiProvider } from '../../providers/api/api';
import { CommonProvider } from '../../providers/common/common';

@Component({
  selector: 'rss',
  templateUrl: 'rss.html'
})
export class RssComponent {
  @Input() rss_id;
  @Input() page_name;
  rss_data = [];
  feed_list = [];
  grids = [];
  text: string;
  display_rss_id;
  number_column = 2;
  number_row = 1;
  col_24 = null;
  col_32 = null;
  col_48 = true;
  col_96 = null;
  slide_config = {perview:2};

  constructor(
    public navCtrl: NavController,
    public apiProv: ApiProvider,
    public comProv: CommonProvider,
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    let rss_id = changes['rss_id'].currentValue;
    this.text = rss_id;
    if (!rss_id) {
      return;
    }

    this.display_rss_id = 'display_rss_id_' + rss_id + '_' +  new Date().getTime();
    this.rss_data = this.comProv.getRssData(rss_id);
    if (!this.rss_data['feed_url']) {
      return;
    }
    if (this.rss_data['number_column']) {
      this.number_column =this.rss_data['number_column'];
    }
    if (this.rss_data['number_row']) {
      this.number_row =this.rss_data['number_row'];
    }
    if (this.number_column == 1) {
      this.col_24 = null;
      this.col_32 = null;
      this.col_48 = null;
      this.col_96 = true;
    } else if (this.number_column == 3) {
      this.col_24 = null;
      this.col_32 = true;
      this.col_48 = null;
      this.col_96 = null;
    } else if (this.number_column == 4) {
      this.col_24 = true;
      this.col_32 = null;
      this.col_48 = null;
      this.col_96 = null;
    }
    this.slide_config['perview'] = this.rss_data['number_column'];

    if (this.rss_data['css']) {
      let css = this.rss_data['css'].replace(/.rss_css/g, '.' + this.display_rss_id + ' ');
      let style = document.createElement('style');
      style.textContent = css;
      document.head.appendChild(style);
    }

    if (!this.rss_data['is_use_bearer_token']) {
      this.getFeed();
    }

    setTimeout(() => {
      let parent_el;
      let marker_el;
      let rss_el;
      let rss_child_el = document.querySelector('.' + this.display_rss_id);
      if (rss_child_el) {
        rss_el = rss_child_el.parentNode;
      }
      
      if (this.page_name == 'home') {
        parent_el = document.querySelector('#topmenu');
        let rss_row_els = document.getElementsByClassName('rss-row');
        if (rss_row_els) {
          for (let i = 0; i < rss_row_els.length; i++ ) {
            if (rss_row_els[i].getAttribute('rss_id') == rss_id) {
              marker_el = rss_row_els[i];
              break;
            }
          }
        }
      } else if (this.page_name == 'sanitizer') {
        let parent_els = document.getElementsByClassName('parent_rss');
        if (parent_els) {
          for (let i = 0; i < parent_els.length; i++ ) {
            if (parent_els[i].getAttribute('rss_id') == rss_id) {
              parent_el = parent_els[i];
              marker_el = parent_els[i].querySelector('.marker_rss');
            }
          }
        }
      }
      if (parent_el && marker_el && rss_el) {
        parent_el.insertBefore(rss_el, marker_el);
        marker_el.innerHTML = '';
      }
    }, 1)
  }

  getTokenFeed() {
    if (!this.rss_data['is_use_bearer_token']) {
      return;
    }

    this.getFeed();
  }

  getFeed() {
    this.apiProv.getFeed(this.rss_data['feed_url'], null, this.rss_data['is_use_bearer_token'])
    .then(data => {
      if (!data) {
        return;
      }
      let parser = new DOMParser();
      let xml_doc = parser.parseFromString(data, 'text/xml');
      if (!xml_doc) {
        return;
      }

      let item = xml_doc.getElementsByTagName('item');

      // 表示数
      let max_length = 20;
      if (this.rss_data['display_type'] == 0) {
        max_length = this.number_column * this.number_row;
      } else if (this.rss_data['display_type'] == 2) {
        max_length = this.number_row;
      }
      if (item.length < max_length) {
        max_length = item.length;
      }
      // オプション表示
      let option_tags = [];
      if (this.rss_data['option_tag']) {
        option_tags = this.rss_data['option_tag'].split('+');
      }

      for (var i = 0; i < max_length; i++) {
        let feed_data = {};
        let title = this.getNodeValue(item[i], 'title');

        let format_date;
        if (this.rss_data['is_display_date']) {
          format_date = this.getNodeValue(item[i], 'pubDate');
        }

        let image_url;
        if (item[i].getElementsByTagName('enclosure')[0]) {
          image_url = item[i].getElementsByTagName('enclosure')[0].getAttribute('url');
        } else if (item[i].getElementsByTagName('media:content')[0]) {
          image_url = item[i].getElementsByTagName('media:content')[0].getAttribute('url');
        }

        let option;
        if (this.rss_data['option_tag']) {
          let option_el = item[i];
          for (let j = 0; j < option_tags.length; j++ ) {
            let option_tag = option_tags[j];
            if (!option_el.getElementsByTagName(option_tag)[0]) {
              break;
            }
            if (j + 1 >= option_tags.length) {
              option = this.getNodeValue(option_el, option_tag);
              break;
            } else {
              option_el = option_el.getElementsByTagName(option_tag)[0];
            }
          }
        }
        let link = this.getNodeValue(item[i], 'link');

        feed_data['title']       = title;
        feed_data['format_date'] = format_date;
        feed_data['image_url']   = image_url;
        feed_data['option']      = option;
        feed_data['link_url']    = link;

        this.feed_list[i] = feed_data;
      }
      this.grids = this.setGrid(this.feed_list);
    }).catch(error => {
      console.log('error', error);
    });
  }

  setGrid(list) {
    let grid = [];
    for (let i = 0; i < list.length; i += this.number_column) {
      let row = list.slice(i, i + this.number_column);
      grid.push(row);
    }

    return grid;
  }

  getNodeValue(element, tag_name) {
    let node_value;
    if (!element.getElementsByTagName(tag_name)[0]) {
      return node_value;
    }
    if (!element.getElementsByTagName(tag_name)[0].childNodes[0]) {
      return node_value;
    }

    node_value = element.getElementsByTagName(tag_name)[0].childNodes[0].nodeValue;
    if (tag_name == 'pubDate') {
      node_value = this.comProv.formatDate(new Date(node_value), 'YYYY/MM/DD');
    }

    return node_value;
  }

  goDetail(data) {
    if (!this.rss_data['is_link_detail']) {
      return;
    }
    if (!data['link_url']) {
      return;
    }
    this.comProv.checkLink(data['link_url'], this.navCtrl);
  }

  goAll() {
    if (!this.rss_data['all_link_url']) {
      return;
    }
    this.comProv.checkLink(this.rss_data['all_link_url'], this.navCtrl);
  }
}


// WEBPACK FOOTER //
// ./src/components/rss/rss.ts